import { Box } from "@mui/joy";
import DarkTypography from "components/common/DarkTypography";
import PersonChip from "components/common/PersonChip";
import { excursionPersonChipOnGradientSx } from "styles/globalStyles";
import { normalizeBookingStatusForPersonChip } from "../../../excursions/shared/utils/excursionUtils";
import { formatParamValue, isLabeledArray } from "./excursionTooltipHelpers";

export default function ExcursionTooltipParamEntry({
  label,
  value,
  color,
}: {
  label: string;
  value: unknown;
  color: string;
}) {
  if (isLabeledArray(value)) {
    return (
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, flexWrap: "wrap" }}>
        <DarkTypography level="body-xs" sx={{ color }}>
          {label}:
        </DarkTypography>
        {value.map((item) => {
          const bs = normalizeBookingStatusForPersonChip(item.booking_status);

          return (
            <PersonChip
              key={item.id}
              size="sm"
              variant="soft"
              label={item.label}
              bookingStatus={bs}
              sx={excursionPersonChipOnGradientSx}
            />
          );
        })}
      </Box>
    );
  }

  return (
    <DarkTypography level="body-xs" sx={{ color }}>
      {label}: {formatParamValue(value)}
    </DarkTypography>
  );
}
